export default "__VITE_ASSET__CXosp$QS__"